import { forwardRef } from 'react'
import PropTypes from 'prop-types'

import theme from 'theme'

const arrowDirectionStyles = {
  top: {
    bottom: -6,
    borderTop: '6px solid'
  },
  bottom: {
    top: -6,
    borderBottom: '6px solid'
  }
}

export function PopoverArrow({
  arrowLeft,
  arrowColor,
  arrowDirection,
  ...rest
}) {
  return (
    <b
      css={[
        {
          position: 'absolute',
          left: arrowLeft,
          marginLeft: -6,
          color: arrowColor,
          borderTopColor: 'currentColor',
          borderBottomColor: 'currentColor',
          borderRight: '6px solid transparent',
          borderLeft: '6px solid transparent'
        },
        arrowDirectionStyles[arrowDirection]
      ]}
      {...rest}
    />
  )
}

PopoverArrow.propTypes = {
  className: PropTypes.string,
  arrowLeft: PropTypes.number,
  arrowDirection: PropTypes.oneOf(['top', 'bottom']),
  arrowColor: PropTypes.string.isRequired
}

PopoverArrow.defaultProps = {
  className: '',
  arrowDirection: 'top'
}

const CardTooltip = forwardRef(
  (
    {
      arrowLeft,
      arrowDirection,
      displayArrow,
      className,
      children,
      size,
      variation
    },
    ref
  ) => {
    // Creating var to pass to arrow color automagically
    const getPanelBackgroundColor = () => {
      switch (variation) {
        case 'light':
          return theme.colors.white[0]
        case 'dark':
          return theme.colors.steel[2]
        case 'primary':
          return theme.colors.green[0]
      }
    }

    return (
      <div
        ref={ref}
        className={className}
        css={[
          {
            borderRadius: theme.borderRadius[0],
            zIndex: theme.zIndices[5],
            cursor: 'default',
            padding: size === 'small' ? theme.space[2] : theme.space[3],
            background: getPanelBackgroundColor(),
            overscrollBehavior: 'contain', // Locks scrolling to the contents of the dropdown
            maxHeight: 'calc(100vh - var(--header-height))' // This "should" be our largest dropdown height since it sits at the top of the app. Adding in a max-height will enable teh `overflowscrollBehavior` to kick-in and handle any extra content
          },

          variation === 'light' && {
            border: theme.border.base,
            boxShadow: theme.boxShadows.small
          }
        ]}
        onClick={e => e.stopPropagation()}
      >
        {children}
        {displayArrow && (
          <PopoverArrow
            arrowColor={getPanelBackgroundColor()}
            arrowDirection={arrowDirection}
            arrowLeft={arrowLeft}
          />
        )}
      </div>
    )
  }
)

CardTooltip.propTypes = {
  className: PropTypes.any,
  children: PropTypes.any,
  displayArrow: PropTypes.bool,
  // From Popover's getPopoverProps fn
  arrowLeft: PropTypes.number,
  arrowDirection: PropTypes.oneOf(['top', 'bottom']),
  size: PropTypes.oneOf(['base', 'small']),
  variation: PropTypes.oneOf(['light', 'dark', 'primary'])
}

CardTooltip.defaultProps = {
  size: 'base',
  variation: 'light'
}

export default CardTooltip
